import {
  IntegrationCategory,
  IntegrationStatus,
  IntegrationType,
} from 'models/InternalIntegrationSetting';
import { IntegrationsBadgeFilter } from 'pages/integrations/IntegrationsTabs.constants';
import useFetchIntegrationSettingsList from '../../../hooks/useFetchIntegrationSettingsList';

const useFetchFeaturedChannels = () => {
  const { data, isLoading } = useFetchIntegrationSettingsList({
    type: IntegrationType.CHANNEL,
    category: IntegrationCategory.DIRECT_CHANNEL,
    badgeFilter: IntegrationsBadgeFilter.WITH_BADGES,
  });

  const featuredChannels = data?.data.filter(
    ({ agencySettings }) => agencySettings.status === IntegrationStatus.ACTIVE,
  );
  const isEmpty = !featuredChannels?.length;

  return { isLoading, featuredChannels, isEmpty };
};

export default useFetchFeaturedChannels;
